import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CmsserviceService } from '../../common-cms-service/cmsservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

declare var $: any;

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.css'],
    standalone: false
})
export class TestComponent implements OnInit, OnDestroy {
  title = 'GCSE Test Calendar';
  filters: any = { categoryId: null, pattern: null, mode: null, month: null, center: null };

  categories: string[] = ['GCSE Full Mocks', 'GCSE Mini Mocks'];
  patterns: string[] = ['AQA', 'OCR', 'Edexcel'];

  months = [
    { label: 'January', value: 1 }, { label: 'February', value: 2 }, { label: 'March', value: 3 },
    { label: 'April', value: 4 }, { label: 'May', value: 5 }, { label: 'June', value: 6 },
    { label: 'July', value: 7 }, { label: 'August', value: 8 }, { label: 'September', value: 9 },
    { label: 'October', value: 10 }, { label: 'November', value: 11 }, { label: 'December', value: 12 },
  ];
  centers: string[] = [];

  testList: any[] = [];
  allTests: any[] = [];

  ngUnsubscribe = new Subject<void>();

  constructor(
    private router: ActivatedRoute,
    private titleService: Title,
    private categoryProduct: CmsserviceService,
    private route: Router,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.fetchTests();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  resetFilters() {
    this.filters = { categoryId: null, pattern: null, mode: null, month: null, center: null };
    this.applyFilters();
  }

  fetchTests() {
    let formData: any = {
      release: 'new',
      exam_type: 'both',
      search: '',
      page: 1,
      user_id: +localStorage.getItem('userid') || 0
    };

    $('.loader-bg').fadeIn();

    this.categoryProduct.getTestList(formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        $('.loader-bg').fadeOut();

        let rawTests = res && res.data ? res.data : [];

        // Only GCSE related
        this.allTests = rawTests.filter((t: any) => {
          let cat = (t.category || '').toLowerCase();
          let nm = (t.test_name || '').toLowerCase();
          return (cat.includes('gcse') || nm.includes('gcse'));
        });

        console.log('[GCSE] Loaded:', this.allTests.length, 'tests');
        this.centers = this.buildCenters(this.allTests);

        this.applyFilters();
      });
  }

  applyFilters() {
    let filtered = [...this.allTests];

    // Category filter
   // Category filter
if (this.filters.categoryId) {
  let selectedCat = this.filters.categoryId.toLowerCase();

  filtered = filtered.filter(t =>
    (t.category || '').toLowerCase().includes(selectedCat) ||
    (t.test_name || '').toLowerCase().includes(selectedCat)
  );
}


    // Pattern filter
    if (this.filters.pattern) {
      filtered = filtered.filter(t =>
        (t.test_name || '').toLowerCase().includes(this.filters.pattern.toLowerCase())
      );
    }

    // Mode filter
    if (this.filters.mode) {
      if (this.filters.mode === 'Online Session') {
        filtered = filtered.filter(t => t.exam_type === 'Online Session');
      } else if (this.filters.mode === 'Classroom Session') {
        filtered = filtered.filter(t => t.exam_type === 'Classroom Session');
      }
    }

    // Month filter
    if (this.filters.month) {
      filtered = filtered.filter(t => {
        let d = this.parseDate(t.test_date);
        return d.getMonth() + 1 === this.filters.month;
      });
    }

    // Center filter
    if (this.filters.center) {
      filtered = filtered.filter(t =>
        (t.location || t.all_location || '').toLowerCase().includes(this.filters.center.toLowerCase())
      );
    }

    // Sort by date ascending
    filtered.sort((a, b) => {
      let da = this.parseDate(a.test_date);
      let db = this.parseDate(b.test_date);
      return da.getTime() - db.getTime();
    });

    this.testList = filtered;
    console.log('[GCSE] After filters:', this.testList.length, 'tests');
  }

  private buildCenters(list: any[]): string[] {
    let set: any = {};
    for (let i = 0; i < (list || []).length; i++) {
      let v = ((list[i].all_location || list[i].location || '') + '').trim();
      if (v) set[v] = true;
    }
    return Object.keys(set).sort();
  }

  private parseDate(dateStr: string): Date {
    if (!dateStr) return new Date(0);
    let parts = dateStr.match(/\d{1,2}\/\d{1,2}\/\d{4}/);
    if (parts) {
      let [d, m, y] = parts[0].split('/').map(Number);
      return new Date(y, m - 1, d);
    }
    return new Date(0);
  }

  trimChar(str: string, length = 30) {
    if (!str) return '';
    return str.length < length ? str : str.substring(0, length) + '...';
  }
}
